/* eslint-disable import/prefer-default-export */
export const CREATE_ARTICLE_LOADING = "CREATE_ARTICLE_LOADING";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";
export const CREATE_ARTICLE_FAIL = "CREATE_ARTICLE_FAIL";

export const GET_ALL_ARTICLES = "GET_ALL_ARTICLES";
export const GET_ALL_ARTICLES_LOADING = "GET_ALL_ARTICLES_ARTICLES";
export const GET_ALL_ARTICLES_FAIL = "GET_ALL_ARTICLES_FAIL";

export const GET_ONE_ARTICLE = "GET_ONE_ARTICLE";
export const GET_ONE_ARTICLE_LOADING = "GET_ONE_ARTICLE_LOADING";
export const GET_ONE_ARTICLE_FAIL = "GET_ONE_ARTICLE_FAIL";

export const USER_LOGIN_LOADING = "USER_LOGIN_LOADING";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
